import { useState, useEffect } from 'react'
import { Box, Button, Input, VStack } from '@chakra-ui/react'
import { toaster } from '@!/components/ui/toaster'
import { useEmailLogin } from '../hooks/useEmailLogin'

const INPUT_PLACEHOLDER_STYLE = {
  color: 'externalPaymentLogin.inputPlaceholder',
  fontSize: '2xs',
}

const getErrorMessage = (error) => {
  if (error?.response?.status === 401 || error?.response?.status === 404) {
    return 'メールアドレスまたはパスワードが正しくありません'
  }
  return 'ログインに失敗しました。時間をおいて再度お試しください。'
}

export const EmailLoginForm = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { login, isLoading, isSuccess, isError, error } = useEmailLogin()

  const isFormValid = email.length > 0 && password.length > 0

  // ログイン成功時にコイン購入画面へリダイレクト
  useEffect(() => {
    if (isSuccess) {
      window.location.href = '/external_payment/coin_purchase'
    }
  }, [isSuccess])

  // エラー発生時にトーストを表示
  useEffect(() => {
    if (isError && error) {
      toaster.create({
        title: 'エラー',
        description: getErrorMessage(error),
        type: 'error',
        duration: 5000,
        closable: true,
      })
    }
  }, [isError, error])

  const handleSubmit = (e) => {
    e.preventDefault()
    login({ email, password })
  }

  return (
    <form onSubmit={handleSubmit}>
      <VStack gap={4} align="stretch">
        <Box bg="white" borderWidth="0.5px" borderColor="externalPaymentLogin.inputBorder" borderRadius="3px">
          <VStack gap={0} align="stretch">
            <Box px="15px" py="8px">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="メールアドレス"
                border="none"
                px={0}
                fontSize="sm"
                _placeholder={INPUT_PLACEHOLDER_STYLE}
                _focus={{ boxShadow: 'none' }}
              />
            </Box>

            <Box height="1px" bg="externalPaymentLogin.inputSeparator" />

            <Box px="15px" py="8px">
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="パスワード"
                border="none"
                px={0}
                fontSize="sm"
                _placeholder={INPUT_PLACEHOLDER_STYLE}
                _focus={{ boxShadow: 'none' }}
              />
            </Box>
          </VStack>
        </Box>

        <Button
          type="submit"
          w="100%"
          h="40px"
          bg="primary.main"
          color="white"
          disabled={!isFormValid}
          loading={isLoading}
          _hover={{ opacity: 0.8 }}
          fontWeight="600"
          fontSize="sm"
        >
          ログイン
        </Button>
      </VStack>
    </form>
  )
}
